export class IsoToLocalDateTimeMapper {
  static mapper(isoDate: string) {
    const date = new Date(isoDate);
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const dateString = date.toLocaleDateString('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const timeString = date.toLocaleTimeString('es-CO', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: timeZone,
    });

    const offsetMin = date.getTimezoneOffset();
    const sign = offsetMin > 0 ? '-' : '+';
    const time = String(Math.floor(Math.abs(offsetMin) / 60)).padStart(2, '0');
    const minutes = String(Math.abs(offsetMin) % 60).padStart(2, '0');
    const offsetStr = `${sign}${time}:${minutes}`;

    return {
      date: dateString,
      time: `${timeString}${offsetStr}`,
    };
  }
}
